module.exports = __webpack_public_path__ + "static/media/QuickERP.464f079b.png";